'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSelectors = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _reselect = require('reselect');

var _dtmLinkAppend = require('acq-components/lib/utils/DTM/dtmLinkAppend');

var _componentHelpers = require('../../utils/component-helpers');

var _common = require('./common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultSelectors = {
  getTitle: function getTitle() {
    return '';
  },
  getDescArray: function getDescArray() {
    return [];
  },
  getSubTitle: function getSubTitle() {
    return '';
  },
  getContentArray: function getContentArray() {
    return [];
  },
  getQeId: function getQeId() {
    return '';
  }
};

var getContentArrayGetter = function getContentArrayGetter(identifier) {
  return function () {
    var contentArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var pageDtmInfo = arguments[1];

    if (identifier !== 'whyAmex') {
      return contentArray;
    }

    return contentArray.map(function (contentObj) {
      if (!contentObj.learnMore || !contentObj.learnMore.dtm) {
        return contentObj;
      }

      return (0, _extends3.default)({}, contentObj, {
        learnMore: (0, _extends3.default)({}, contentObj.learnMore, {
          url: (0, _dtmLinkAppend.appendLinkNav)(contentObj.learnMore.url, contentObj.learnMore.dtm.type || DTM_CONSTS.defaultNavType, pageDtmInfo.linkNavBase, pageDtmInfo.pageName, contentObj.learnMore.dtm.tag)
        })
      });
    });
  };
};

// labels
var getSelectors = exports.getSelectors = function getSelectors(identifier, isOnPage) {
  if (isOnPage) {
    return (0, _extends3.default)({}, defaultSelectors, {
      getTitle: function getTitle(state) {
        return (0, _lodash2.default)(state.intlPage, 'page.' + identifier + '.header') || [];
      },
      getDescription: function getDescription(state) {
        return (0, _componentHelpers.concactDescStr)((0, _lodash2.default)(state.intlPage, 'page.' + identifier + '.desc'));
      },
      getContentArray: (0, _reselect.createSelector)([function (state) {
        return (0, _lodash2.default)(state.intlPage, 'page.' + identifier + '.content') || [];
      }, function (state) {
        return (0, _lodash2.default)(state.intlPage, 'dtm') || {};
      }], getContentArrayGetter(identifier)),
      getQeId: function getQeId(state) {
        return (0, _lodash2.default)(state.intlPage, 'page.' + identifier + '.qeId') || '';
      }
    });
  }

  return (0, _extends3.default)({}, defaultSelectors, {
    getDescription: (0, _reselect.createSelector)(_common.getCardData, function (cardData) {
      return (0, _componentHelpers.concactDescStr)((0, _lodash2.default)(cardData, identifier + '.desc'));
    }),
    getTitle: (0, _reselect.createSelector)(_common.getCardData, function (cardData) {
      return (0, _lodash2.default)(cardData, identifier + '.header') || '';
    }),
    getContentArray: (0, _reselect.createSelector)(_common.getCardData, function (cardData) {
      return (0, _lodash2.default)(cardData, identifier + '.content') || [];
    }),
    getQeId: (0, _reselect.createSelector)(_common.getCardData, function (cardData) {
      return (0, _lodash2.default)(cardData, identifier + '.qeId') || '';
    })
  });
};